import capitalize from 'lodash/capitalize';
import snakeCase from 'lodash/snakeCase';
export const licenseTypesMap = {
  academic: 'Paid',
  commercial: 'Paid',
  community: 'Free',
  demonstration: 'Free',
  open_source: 'Free',
  free: 'Free'
};
export const licenseDetailsConfig = [{
  head: 'CUSTOMER INFORMATION',
  content: [{
    label: 'Company',
    apiKeyPath: 'contactDetails.company'
  }, {
    label: 'Country',
    apiKeyPath: 'contactDetails.country'
  }, {
    label: 'Region',
    apiKeyPath: 'contactDetails.region'
  }]
}, {
  head: 'MAINTENANCE PERIOD',
  content: [{
    label: 'Start date',
    apiKeyPath: 'maintenanceStartDate'
  }, {
    label: 'End date',
    apiKeyPath: 'maintenanceEndDate'
  }]
}, {
  head: 'CUSTOMER BILLING CONTACT',
  content: [{
    label: 'Billing contact name',
    apiKeyPath: 'contactDetails.billingContact.name'
  }, {
    label: 'Billing contact email',
    apiKeyPath: 'contactDetails.billingContact.email'
  }, {
    label: 'Address',
    apiKeyPath: 'contactDetails.billingContact.address1'
  }, {
    label: 'City',
    apiKeyPath: 'contactDetails.billingContact.city'
  }, {
    label: 'Phone',
    apiKeyPath: 'contactDetails.billingContact.phone'
  }, {
    label: 'Postcode',
    apiKeyPath: 'contactDetails.billingContact.postCode'
  }]
}, {
  head: 'CUSTOMER TECHNICAL CONTACT',
  content: [{
    label: 'Technical contact name',
    apiKeyPath: 'contactDetails.technicalContact.name'
  }, {
    label: 'Technical contact email',
    apiKeyPath: 'contactDetails.technicalContact.email'
  }, {
    label: 'Address',
    apiKeyPath: 'contactDetails.technicalContact.address1'
  }, {
    label: 'City',
    apiKeyPath: 'contactDetails.technicalContact.city'
  }, {
    label: 'Phone',
    apiKeyPath: 'contactDetails.technicalContact.phone'
  }, {
    label: 'Postcode',
    apiKeyPath: 'contactDetails.technicalContact.postCode'
  }]
}, {
  head: 'LICENSE DETAILS',
  content: [{
    label: 'Addon license ID',
    apiKeyPath: 'addonLicenseId',
    hideOnNull: true
  }, {
    label: 'Host license ID',
    apiKeyPath: 'hostLicenseId',
    hideOnNull: true
  }, {
    label: 'License ID',
    apiKeyPath: 'licenseId',
    hideOnNull: true
  }, {
    label: 'Host entitlement number',
    apiKeyPath: 'hostEntitlementNumber',
    hideOnNull: true
  }, {
    label: 'App entitlement number',
    apiKeyPath: 'appEntitlementNumber',
    hideOnNull: true
  }, {
    label: 'Cloud ID',
    apiKeyPath: 'cloudId',
    hideOnNull: true
  }, {
    label: 'Addon key',
    apiKeyPath: 'addonKey'
  }, {
    label: 'Addon name',
    apiKeyPath: 'addonName'
  }, {
    label: 'License type',
    condition: license => {
      const licenseTypeMapValue = licenseTypesMap[snakeCase(license.licenseType)];
      const licenseType = capitalize(license.licenseType);
      return licenseTypeMapValue ? "".concat(licenseTypeMapValue, ", ").concat(licenseType) : licenseType;
    }
  }, {
    label: 'Status',
    apiKeyPath: 'status'
  }, {
    label: 'Hosting',
    apiKeyPath: 'hosting'
  }, {
    label: 'Tier',
    apiKeyPath: 'tier'
  }]
}, {
  head: 'PARTNER INFORMATION',
  content: [{
    label: 'Partner name',
    apiKeyPath: 'partnerDetails.partnerName'
  }, {
    label: 'Partner type',
    apiKeyPath: 'partnerDetails.partnerType'
  }, {
    label: 'Partner contact name',
    apiKeyPath: 'partnerDetails.billingContact.name'
  }, {
    label: 'Partner contact email',
    apiKeyPath: 'partnerDetails.billingContact.email'
  }]
}];